<template>
    <span :class="addedStyles">
        <a href="#" v-if="resourceName === 'instances'" @click.prevent="showInstanceQuotaIncrease()">Change quota</a>
        <a href="#" v-if="resourceName === 'volumes'" @click.prevent="showVolumeQuotaIncrease()">Change quota</a>
    </span>
</template>

<script>
export default {
    props: ['resourceName', 'addedStyles'],

    methods: {
        showInstanceQuotaIncrease() {
            this.$store.commit('volumev3/UPDATE_KEY');
            this.$store.commit('instance/ACTIVE_QUOTA', true);
            this.$store.commit('volumev3/ACTIVE_QUOTA', false);
            this.osModal('SHOW_FORM_QUOTA_INCREASE');
        },

        showVolumeQuotaIncrease() {
            this.$store.commit('volumev3/UPDATE_KEY');
            this.$store.commit('instance/ACTIVE_QUOTA', false);
            this.$store.commit('volumev3/ACTIVE_QUOTA', true);
            this.osModal('SHOW_FORM_QUOTA_INCREASE');
        },
    },
}
</script>
